import styled from "styled-components";

export default styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 15px 0;

    .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-grow: 1;

        padding: 0 15px;

        .name {
            display: flex;
            font-weight: bolder;
            letter-spacing: 0.1em;
            font-size: 16px;
            color: ${(props) => props.theme.homeListRowHeader};
        }

        .details {
            display: flex;
            flex-direction: row;
            margin: 0 -5px;

            .date {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 0 5px;

                p {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 14px;
                }

                svg {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 10px;
                    margin-right: 4px;
                    margin-bottom: 2px;
                }
            }
        }
    }

    .prices {
        display: flex;
        align-items: center;
        padding: 0 20px;

        .price {
            font-size: 12px;
        }

        .factor {
            font-size: 14px;
            margin-left: 15px;
            font-weight: bolder;

            padding: 1px 5px;

            border-radius: 5px;

            color: white;
            background-color: ${(props) =>
                props.theme.subMenuBadgeBackgroundSecondary};
        }

        svg {
            font-size: 12px;
            margin: 0 5px 2px 5px;
        }
    }

    .date {
        display: flex;
        color: ${(props) => props.theme.homeListRowText};
        font-size: 14px;
        margin: 0 20px;
    }

    .actions {
        .actionsMenuBtn {
            color: ${(props) => props.theme.tableIconHighlight};
        }
    }

    :hover {
        background-color: ${(props) => props.theme.homeListBodyBackgroundHover};
    }
`;
